import React, { Component } from "react";
import Images from "../../Assets/Images";
import '../../Styles/UserAdmin.scss'

class UserDashboard extends Component {  
    render(){
        return (
            <div className="appCont">
              <div className="mainWrapper">
                  <div className="dashboardCont">
                    <div className="dbGrids">
                        <div className="dbRow">
                          <div className="dbCol lBox">
                            <div className="gBox dbConfig">
                                <div className="iconBox">
                                  <img src={Images.DASHBOARDICON} width="16" alt="Dashboard"/>
                                </div>
                                <div className="dbConfigData">
                                  <p>DASHBOARD CONFIGURATION</p>
                                  <h4>5 Selected</h4>
                                </div>
                                <div className="ml-auto configBtn">
                                  <button>Configure</button>
                                </div>
                            </div>
                          </div>
                          <div className="dbCol rBox">
                            <div className="gBox">
                                  <div className="d-flex">
                                    <div className="iconBox">
                                      <img src={Images.ASSESSMENT} width="16" alt="Dashboard"/>
                                    </div>
                                    <div className="dbConfigData">
                                      <p>Total Risks</p>
                                      <h4>4</h4>
                                    </div>
                                  </div>
                                  <div className="d-flex">
                                    <div className="iconBox">
                                      <img src={Images.WARNING} width="16" alt="Dashboard"/>
                                    </div>
                                    <div className="dbConfigData">
                                      <p>Open Risks</p>
                                      <h4>2</h4>
                                    </div>
                                  </div>
                                  <div className="d-flex">
                                    <div className="iconBox">
                                      <img src={Images.ERROR1} width="16" alt="Dashboard"/>
                                    </div>
                                    <div className="dbConfigData">
                                      <p>Active Risks</p>
                                      <h4>2</h4>
                                    </div>
                                  </div>
                                  <div className="d-flex">
                                    <div className="iconBox">
                                      <img src={Images.CHECKCIRCLE} width="16" alt="Dashboard"/>
                                    </div>
                                    <div className="dbConfigData">
                                      <p>Closed Risks</p>
                                      <h4>1</h4>
                                    </div>
                                  </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div className="dbCardsCont">
                      <div className="dbCard card50">
                        <div className="gridBox">
                            <div className="gridHeader">
                              <div className="d-flex align-items-center">
                                <h4>My Actions</h4>
                                <div className="ml-auto">
                                  <div className="searchBox">
                                    <span className="searchIcon"><img src={Images.SEARCH} width="12" alt="Search" /></span>
                                    <input type="text" autoComplete="off" placeholder="Search" name="search"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tblCont">
                              <table>
                                <thead>
                                  <tr>
                                    <th>Number</th>
                                    <th>Control</th>
                                    <th>Due Date</th>
                                    <th>Status</th>
                                    <th><div className="text-center">Actions</div></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>ANG-RSK-01-1</td>
                                    <td>Undertake futher design work</td>
                                    <td>24/08/20</td>
                                    <td><span className="statusIcon"><img src={Images.ERROR2} alt="Overdue"/></span>Overdue</td>
                                    <td><a className="more"><img src={Images.MOREICON} alt="More"/></a></td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                            </div>
                        </div>
                      </div>
                      <div className="dbCard card50">
                        <div className="gridBox">
                            <div className="gridHeader">
                              <div className="d-flex align-items-center">
                                <h4>Risks By Impact Level</h4>
                              </div>
                            </div>
                            <div className="chartCont">
                              <img src={Images.CHART} alt="chart"/>
                            </div>
                        </div>
                      </div>
                      <div className="dbCard card100">
                        <div className="gridBox">
                            <div className="gridHeader">
                              <div className="d-flex align-items-center">
                                <h4>Risk Register</h4>
                                <div className="ml-auto d-flex">
                                  <div className="btnGreen">
                                    <button>Add Risk</button>
                                  </div>
                                  <div className="searchBox">
                                    <span className="searchIcon"><img src={Images.SEARCH} width="12" alt="Search" /></span>
                                    <input type="text" autoComplete="off" placeholder="Search" name="search"/>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tblCont">
                              <table>
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th>Number</th>
                                    <th>Risk</th>
                                    <th>Risk Type</th>
                                    <th>Elevation</th>
                                    <th>Project Stage</th>
                                    <th>Cause</th>
                                    <th>Existing Control</th>
                                    <th>Frequency</th>
                                    <th><div className="text-center">Actions</div></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td><a className="more"><img src={Images.EDITICON} width="12" alt="More"/></a></td>
                                    <td width="100">ANG-RSK-01</td>
                                    <td>There is a risk that reinjection
                                        rates may not be achieved</td>
                                    <td>Design</td>
                                    <td width="100"><span className="statusIcon"><img src={Images.ERROR2} alt="Overdue"/></span>Elevated</td>
                                    <td>Development</td>
                                    <td>Plant performances
                                        out of specification</td>
                                    <td>Injection water management
                                        included in design</td>
                                    <td>10.00%</td>
                                    <td><a className="more"><img src={Images.MOREICON} alt="More"/></a></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                        </div>
                      </div>
                      <div className="dbCard card50">
                        <div className="gridBox">
                            <div className="gridHeader">
                              <div className="d-flex align-items-center">
                                <h4>Chart 1</h4>
                              </div>
                            </div>
                            <div className="chartCont">
                                <img src={Images.CHART} alt="chart"/>
                            </div>
                        </div>
                      </div>
                      <div className="dbCard card50">
                        <div className="gridBox">
                            <div className="gridHeader">
                              <div className="d-flex align-items-center">
                                <h4>Chart 2</h4>
                              </div>
                            </div>
                            <div className="chartCont">
                              <img src={Images.CHART} alt="chart"/>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <div className="rightSidebar ml-auto">
                <h3>ANG-RSK-02</h3>
                <div className="gridHeader">
                  <div className="d-flex align-items-center">
                    <h4>My Actions</h4>
                    <div className="ml-auto">
                      <div className="searchBox">
                        <span className="searchIcon"><img src={Images.SEARCH} width="12" alt="Search" /></span>
                        <input type="text" autoComplete="off" placeholder="Search" name="search"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dropDownCont">
                  <div className="ddLabel d-flex">
                    <label>ANG-RSK-01-1</label>
                    <span className="ml-auto"><img src={Images.EXPAND} alt="Expand"/></span>
                  </div>
                </div>
              </div>
            </div>
    

);
        }
};
export default UserDashboard;
